import axios from "axios";
import { authApi } from "../_constants/api.constant"
import {setUserId} from '../../_helpers/auth/secureToken'
export async function login(data) {
  const response = await axios.post(
    authApi.LOGIN,
    data,
  ).then(function (response) {
    //localStorage.setItem("userId", response.data.data[0].id);
    setUserId(response.data.data[0].id)
    return response;
  }).catch(function (error) {

    if (error.response) {
   
      return (error.response)

    }
    else return (error);

  });


  return response;
}

export async function captchaEnableService(username) {
  const response = await axios.post(
    authApi.CAPTCHA_ENABLE,
    { username },
  ).then(function (result) {
    return result;
  }).catch(function (error) {
    if (error.response) {
      return error.response;
    }
    return error;
  });

  return response;
}

export async function captchaGenerateService() {
  const response = await axios.get(
    authApi.CAPTCHA_GENERATE,
  ).then(function (result) {
    return result;
  }).catch(function (error) {
    if (error.response) {
      return error.response;
    }
    return error;
  });

  return response;
}
